import { FC, useState, useEffect } from 'react';
import { GeneratedLinkUrlObject } from 'src/utils/links';
import cn from 'classnames';
import NavigationLink from '../NavigationLink/NavigationLink';

interface PageNumberProps {
  selectedPages: number[];
  pageIndex: number;
  getPaginationLink: (pageIndex: number) => GeneratedLinkUrlObject;
}

const PageNumber: FC<PageNumberProps> = ({
  pageIndex,
  getPaginationLink,
  selectedPages
}) => {
  const ButtonsStyles = {
    active: 'text-white bg-darkBlue border-darkBlue',
    inActiveList: 'text-astronautBlue bg-white border-astronautBlue',
    inactive: 'text-silver bg-white border-silver'
  };
  const getButtonStyles = () => {
    if (pageIndex === selectedPages[selectedPages?.length - 1]) {
      return ButtonsStyles.active;
    }
    return selectedPages?.includes(pageIndex)
      ? ButtonsStyles.inActiveList
      : ButtonsStyles.inactive;
  };
  const [link, setLink] = useState(getPaginationLink(pageIndex));

  useEffect(() => {
    setLink(getPaginationLink(pageIndex));
  }, [pageIndex, getPaginationLink]);

  return (
    <NavigationLink
      key={`pageLink_${pageIndex}`}
      href={link}
      passClassName={cn(
        'w-6 h-6 rounded-md border fs-caption-reg overflow-hidden flex items-center justify-center',
        getButtonStyles()
      )}
    >
      <p>{pageIndex}</p>
    </NavigationLink>
  );
};

export default PageNumber;
